module.exports = __webpack_public_path__ + "static/img/idealproteinfoods.9c2c4d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/idealproteinfoods.jpg
// module id = 95
// module chunks = 1